module.exports = __webpack_public_path__ + "static/media/framing-section.8addb2b4.webp";